import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from "../../../environments/environment";
import { MessageService } from '../../core/service/message.service';
import { PropertyDropDown } from '../../shared/models/property-dd.model';
import { PropertyDetails } from '../../shared/models/property.model';
import { CommonService } from './common.service';

export interface Todo {
  id: number | string;
  propertyName: string;
}

const BACKEND_URL = environment.apiUrl + "/property/";
const BACKEND_URL_zillow = environment.apiUrl + "/zillow";

@Injectable({
  providedIn: 'root'
})
export class PropertyService {

  isWorking = false;
  private propertyDD: PropertyDropDown[] = [];
  zillowresponse: any[]
  private propertyDDUpdated = new Subject<{ propertyDD: PropertyDropDown[]; }>();
  private propertyView: PropertyDetails[] = [];
  private propertyUpdated = new Subject<{ propertyView: PropertyDetails[]; }>();
  private zestimatedata
  private zillowUpdated = new Subject<{ zestimate: any[] }>();
  public defaultProperty: string;
  public selectedProperty: string;

  mySubscription: any;

  constructor(private commonServ: CommonService,
    private http: HttpClient,
    private messageService: MessageService, private route: ActivatedRoute,
    private router: Router) { }

  getProgressReport() {
    return this.isWorking = true;
  }

  addPropertyDetails(propertyDetail: any, zillowid) {
    let postData;
    const defaultProp = propertyDetail.DefaultProperty === true ? "Yes" : "No";
    const Airbnb = propertyDetail.PropertyOnAirbnb === true ? "Yes" : "No";
    const Homeaway = propertyDetail.PropertyOnHomeaway === true ? "Yes" : "No";
    const Zillow = propertyDetail.PropertyOnZillow === true ? "Yes" : "No";
    if (propertyDetail.Image == null) {
      postData = {
        Default: defaultProp,
        Frequency: propertyDetail.PropertyFrequency,
        OnAirbnb: Airbnb,
        OnHomeaway: Homeaway,
        OnZillow: Zillow,
        Zillow_Id: zillowid,
        RentPerMonth: propertyDetail.PropertyRentPerMonth,
        State: propertyDetail.propertyState,
        City: propertyDetail.propertyCity,
        NickName: propertyDetail.propertyNickName,
        UnitNumber: propertyDetail.propertyUnitNumber,
        ZipCode: propertyDetail.propertyZipCode,
        streetAddress: propertyDetail.streetAddress,
        ImageFilePath: "",
        FileName: "",
        isImage: "N"

      }
    }
    // else if (typeof propertyDetail.Image === "object") {
    //   postData = new FormData();
    //   postData.append('Default', defaultProp);
    //   postData.append("Frequency", propertyDetail.PropertyFrequency);
    //   postData.append("OnAirbnb", Airbnb);
    //   postData.append("OnHomeaway", Homeaway);
    //   postData.append("OnZillow", Zillow);
    //   postData.append("Zillow_Id", zillowid);
    //   postData.append("RentPerMonth", propertyDetail.PropertyRentPerMonth);
    //   postData.append("State", propertyDetail.propertyState);
    //   postData.append("City", propertyDetail.propertyCity);
    //   postData.append("NickName", propertyDetail.propertyNickName);
    //   postData.append("UnitNumber", propertyDetail.propertyUnitNumber);
    //   postData.append("ZipCode", propertyDetail.propertyZipCode);
    //   postData.append("streetAddress", propertyDetail.streetAddress);
    //   postData.append("Image", propertyDetail.Image, propertyDetail.Image.name);

    // }
    else {
      postData = {
        Default: defaultProp,
        Frequency: propertyDetail.PropertyFrequency,
        OnAirbnb: Airbnb,
        OnHomeaway: Homeaway,
        OnZillow: Zillow,
        Zillow_Id: zillowid,
        RentPerMonth: propertyDetail.PropertyRentPerMonth,
        State: propertyDetail.propertyState,
        City: propertyDetail.propertyCity,
        NickName: propertyDetail.propertyNickName,
        UnitNumber: propertyDetail.propertyUnitNumber,
        ZipCode: propertyDetail.propertyZipCode,
        streetAddress: propertyDetail.streetAddress,
        ImageFilePath: propertyDetail.Image.split("&")[0],
        FileName: propertyDetail.Image.split("&")[1],
        isImage: "Y"
      }
    }
    this.http
      .post<{ message: string; property: PropertyDetails, Response: any }>(
        BACKEND_URL,
        postData, {
        params: {
          UserId: localStorage.getItem("userId"),
        }
      }).subscribe(propertyData => {
        // console.log("propertyData");
        // console.log(propertyData);
        // if(propertyData.property.imagePath==""){
        //   propertyData.property.imagePath="assets/images/big/blank.jpg"
        // }
        if (propertyData.Response.Code == '1000') {
          const PropertyD: PropertyDetails = {
            Id: propertyData.property.Id,
            Nickname: propertyDetail.propertyNickName,
            Street_Address: propertyDetail.streetAddress,
            Unit_Number: propertyDetail.propertyUnitNumber,
            City: propertyDetail.propertyCity,
            State: propertyDetail.propertyState,
            ZIPcode: propertyDetail.propertyZipCode,
            Default: defaultProp,
            Zillow_Opt: Zillow,
            Zillow_Id: zillowid,
            Airbnb_Listed: Airbnb,
            Homeway_Listed: Homeaway,
            Rent_Per_Month: propertyDetail.PropertyRentPerMonth,
            Rent_Frequency: propertyDetail.PropertyFrequency,
            Activate: "1",
            User_Id: localStorage.getItem("userId"),
            RemoveProperty: "N",
            imagePath: "assets/images/big/blank.jpg"//propertyData.property.imagePath
          }
          const PropertyDropD: PropertyDropDown = {
            id: propertyData.property.Id,
            Nickname: propertyDetail.propertyNickName,
            Default: propertyDetail.defaultProp,
            RentFrequency: propertyDetail.Rent_Frequency
          }
          // for drop down 
          this.propertyDD.push(PropertyDropD);
          this.propertyDDUpdated.next({
            propertyDD: [...this.propertyDD]
          })
          //End

          this.propertyView.push(PropertyD);
          this.propertyUpdated.next({
            propertyView: [...this.propertyView]
          })
          this.commonServ.showSuccessMessageforAdd("Property");
          this.getpropertyCard();
          this.getPropertyList();
        }
        else {

        }
      });
  }

  // for edit Property Details
  editPropertyDetails(propertyDetail: any, Zillowid) {
    let postData;
    const propertyId = propertyDetail.propertyId;
    const defaultProp = propertyDetail.DefaultProperty === true ? "Yes" : "No";
    const Airbnb = propertyDetail.PropertyOnAirbnb === true ? "Yes" : "No";
    const Homeaway = propertyDetail.PropertyOnHomeaway === true ? "Yes" : "No";
    const Zillow = propertyDetail.PropertyOnZillow === true ? "Yes" : "No";
    if (propertyDetail.Image == null) {
      postData = new FormData();
      postData.append('Default', defaultProp);
      postData.append("Frequency", propertyDetail.PropertyFrequency);
      postData.append("OnAirbnb", Airbnb);
      postData.append("OnHomeaway", Homeaway);
      postData.append("OnZillow", Zillow);
      postData.append("Zillow_Id", Zillowid);
      postData.append("RentPerMonth", propertyDetail.PropertyRentPerMonth);
      postData.append("State", propertyDetail.propertyState);
      postData.append("City", propertyDetail.propertyCity);
      postData.append("NickName", propertyDetail.propertyNickName);
      postData.append("UnitNumber", propertyDetail.propertyUnitNumber);
      postData.append("ZipCode", propertyDetail.propertyZipCode);
      postData.append("streetAddress", propertyDetail.streetAddress);
      postData.append("ImageFilePath", "");
      postData.append("FileName", "");
      postData.append("isImage", "N");
    }
    else {
      if (typeof propertyDetail.Image === "object") {
        postData = {
          Default: defaultProp,
          Frequency: propertyDetail.PropertyFrequency,
          OnAirbnb: Airbnb,
          OnHomeaway: Homeaway,
          OnZillow: Zillow,
          Zillow_Id: Zillowid,
          RentPerMonth: propertyDetail.PropertyRentPerMonth,
          State: propertyDetail.propertyState,
          City: propertyDetail.propertyCity,
          NickName: propertyDetail.propertyNickName,
          UnitNumber: propertyDetail.propertyUnitNumber,
          ZipCode: propertyDetail.propertyZipCode,
          streetAddress: propertyDetail.streetAddress,
          imageAlreadyExist: 'Y',
          isImage: "N"
        }
      }
      else {
        postData = {
          Default: defaultProp,
          Frequency: propertyDetail.PropertyFrequency,
          OnAirbnb: Airbnb,
          OnHomeaway: Homeaway,
          OnZillow: Zillow,
          Zillow_Id: Zillowid,
          RentPerMonth: propertyDetail.PropertyRentPerMonth,
          State: propertyDetail.propertyState,
          City: propertyDetail.propertyCity,
          NickName: propertyDetail.propertyNickName,
          UnitNumber: propertyDetail.propertyUnitNumber,
          ZipCode: propertyDetail.propertyZipCode,
          streetAddress: propertyDetail.streetAddress,
          ImageFilePath: propertyDetail.Image.split("&")[0],
          FileName: propertyDetail.Image.split("&")[1],
          isImage: "Y"
        }
      }
    }
    this.http
      .put<{ message: string; property: PropertyDetails }>(
        BACKEND_URL + propertyId,
        postData, {
        params: {
          UserId: localStorage.getItem("userId"),
        }
      }
      ).subscribe(propertyData => {
        //console.log(propertyData.property)
        const updateDProperty = [...this.propertyView];
        const oldPropertyIndex = updateDProperty.findIndex(p => p.Id === propertyId);
        const PropertyD: PropertyDetails = {
          Id: propertyDetail.propertyId,
          Nickname: propertyDetail.propertyNickName,
          Street_Address: propertyDetail.streetAddress,
          Unit_Number: propertyDetail.propertyUnitNumber,
          City: propertyDetail.propertyCity,
          State: propertyDetail.propertyState,
          ZIPcode: propertyDetail.propertyZipCode,
          Default: defaultProp,
          Zillow_Opt: Zillow,
          Zillow_Id: Zillowid,
          Airbnb_Listed: Airbnb,
          Homeway_Listed: Homeaway,
          Rent_Per_Month: propertyDetail.PropertyRentPerMonth,
          Rent_Frequency: propertyDetail.PropertyFrequency,
          Activate: "1",
          User_Id: localStorage.getItem("userId"),
          RemoveProperty: "N",
          imagePath: "assets/images/big/blank.jpg"//propertyData.property.imagePath
          // Image:propertyDetail
        }

        updateDProperty[oldPropertyIndex] = PropertyD;
        this.propertyView = updateDProperty;
        this.propertyUpdated.next({
          propertyView: [...this.propertyView]
        });
        if (propertyData != undefined) {
          return true;
        }
        // this.authService.showSuccessMessageforUpdate("Property");
        this.getpropertyCard();
        this.getPropertyList();
        this.messageService.sendMessage('Property Updated');

      });

  }
  //   getpropertyCardbyId(Id:string){
  //     this.http
  //     .get<{ message: string; property: PropertyDetails }>(
  //       BACKEND_URL + Id,      
  //     ).subscribe((responseData)=>{
  //  console.log(responseData);
  //     })

  //   }


  // getpropertyCard() {
  //   this.http
  //     .get<{ message: string; propertyView: any; }>(BACKEND_URL + 'cardView')
  //     .pipe(
  //       map(postData => {
  //         return {
  //           propertyView: postData.propertyView.map(propertyD => {
  //             // console.log(propertyD);
  //             return {
  //               Id: propertyD.Id,
  //               Nickname: propertyD.Nickname,
  //               Street_Address: propertyD.Street_Address,
  //               Unit_Number: propertyD.Unit_Number,
  //               City: propertyD.City,
  //               State: propertyD.State,
  //               ZIPcode: propertyD.ZIPcode,
  //               Default: propertyD.Default,
  //               Zillow_Opt: propertyD.Zillow_Opt,
  //               Zillow_Id: propertyD.Zillow_Id,
  //               Airbnb_Listed: propertyD.Airbnb_Listed,
  //               Homeway_Listed: propertyD.Homeway_Listed,
  //               Rent_Per_Month: propertyD.Rent_Per_Month,
  //               Rent_Frequency: propertyD.Rent_Frequency,
  //               User_Id: propertyD.User_Id,
  //               Activate: propertyD.Activate,
  //               Entered_Date: propertyD.Nickname,
  //               RemoveProperty: propertyD.RemoveProperty,
  //               imagePath: "assets/images/big/blank.jpg"//propertyD.imagePath
  //             };
  //           })
  //         };
  //       })
  //     )
  //     .subscribe(transformedProperty => {
  //       this.propertyView = transformedProperty.propertyView;
  //       this.propertyUpdated.next({
  //         propertyView: [...this.propertyView]
  //       });
  //     });
  // }

  getpropertyCard() {
    this.http
      .get<{ message: string; propertyView: any; }>(BACKEND_URL + 'cardView')
      .pipe(
        map(postData => {
          return {
            propertyView: postData.propertyView.map(propertyD => {
              let PropertyImage = "assets/images/big/blank.jpg";
              if (propertyD.imagePath != null) {
                PropertyImage = propertyD.imagePath;
              }
              // console.log(propertyD);
              return {
                Id: propertyD.Id,
                Nickname: propertyD.Nickname,
                Street_Address: propertyD.Street_Address,
                Unit_Number: propertyD.Unit_Number,
                City: propertyD.City,
                State: propertyD.State,
                ZIPcode: propertyD.ZIPcode,
                Default: propertyD.Default,
                Zillow_Opt: propertyD.Zillow_Opt,
                Zillow_Id: propertyD.Zillow_Id,
                Airbnb_Listed: propertyD.Airbnb_Listed,
                Homeway_Listed: propertyD.Homeway_Listed,
                Rent_Per_Month: propertyD.Rent_Per_Month,
                Rent_Frequency: propertyD.Rent_Frequency,
                User_Id: propertyD.User_Id,
                Activate: propertyD.Activate,
                Entered_Date: propertyD.Nickname,
                RemoveProperty: propertyD.RemoveProperty,
                imagePath: PropertyImage//"assets/images/big/blank.jpg"//propertyD.imagePath
              };
            })
          };
        })
      )
      .subscribe(transformedProperty => {
        this.propertyView = transformedProperty.propertyView;
        this.propertyUpdated.next({
          propertyView: [...this.propertyView]
        });
      });
  }

  getPropertyList() {
    this.http.get<{ message: string; propertyList: any; }>(BACKEND_URL + 'propertyList')
      .pipe(
        map(postData => {
          return {
            propertyDD: postData.propertyList.map(propertyL => {
              return {
                id: propertyL.id,
                Nickname: propertyL.Nickname,
                Default: propertyL.Default,
                RentFrequency: propertyL.RentFrequency
              }
            })
          }
        }))
      .subscribe(transformedProperty => {
        this.propertyDD = transformedProperty.propertyDD;
        this.propertyDDUpdated.next({
          propertyDD: [...this.propertyDD]
        })
      });
    //return this.http.get(BACKEND_URL + 'propertyList')
  }

  /*
  setSelectedProperty(){
    const allProperty = [...this.propertyView];
    const default = allProperty.findIndex(p => p.id === expenseId);
  }
  */

  getpropertyUpdateCardListner() {
    return this.propertyUpdated.asObservable();
  }

  getpropertyListListner() {
    return this.propertyDDUpdated.asObservable();
  }

  saveSelectedProperty(value: string) {
    //console.log(value);
    const prevSelectedPro = localStorage.getItem("propertyId");

    const prevSelectedFrequency = localStorage.getItem("selectedPropertyFrequency");
    let charArr = value.split('||');
    let propertyId = charArr[0];
    let curPropertyFrequency = charArr[1];

    const curSelectedPro = propertyId;
    if (prevSelectedPro != curSelectedPro) {
      localStorage.removeItem("propertyId");
      localStorage.setItem("propertyId", propertyId);

      if (this.router.url == '/app/dashboard' || this.router.url.includes('/app/dashboard?refresh')) {
        //window.location.reload();
        // console.log("Inside if");
        // console.log("property Id changed to " + propertyId);
        this.router.navigate(['/app/dashboard'], {
          queryParams: { refresh: new Date().getTime() }
        });
        localStorage.setItem("propertyId", propertyId);
      }
      else {
        // console.log("Inside else");
        this.router.navigate(["/app/dashboard"]);
      }
    }

    if (prevSelectedFrequency != curPropertyFrequency) {
      // console.log("Frequency changed to " + curPropertyFrequency);
      localStorage.removeItem("selectedPropertyFrequency");
      localStorage.setItem("selectedPropertyFrequency", curPropertyFrequency);
    }
  }

  getPropertyDetailsForEdit(Id: string) {
    return this.propertyView.filter(property => property.Id == Id);
  }
  getZillowValidation(propertyDetail: any) {
    //console.log(propertyDetail);
    return this.http.get<{ message: string, Response: JSON }>(
      BACKEND_URL_zillow + "/getDeepSearchResults", {
      params: {
        address: propertyDetail.streetAddress,
        citystatezip: propertyDetail.propertyCity + "" + propertyDetail.propertyZipCode
      }
    })
  }

  getzillowUpdatedListner() {
    return this.zillowUpdated.asObservable();
  }

  deleteProperty(Id, Nickname) {
    let propertyId = {
      id: Id
    };
    this.http.put(BACKEND_URL + 'delete/' + Id,
      propertyId, {
      params: {
        UserId: localStorage.getItem("userId"),
        Nickname: Nickname
      }
    })
      .subscribe(responseData => {
        //console.log(responseData)
        this.getpropertyCard();
        this.getPropertyList();
      })
  }

  getzillowId(Id) {
    return this.http
      .get<{ message: string; Zillow_Id: any; Response: any }>(BACKEND_URL + 'getzillowId/' + Id)
  }

  getzillowDetails(Zillow_Id) {
    this.http.get<{ message: string, Response: any }>(
      BACKEND_URL_zillow + "/getZestimate", {
      params: {
        zpid: Zillow_Id
      }
    }).pipe(
      map(postData => {
        if (postData.Response['Code'] == '1000') {
          return {
            Code: '1000',
            zillowres: postData.Response["Searchresults"].map(zillowD => {
              if (zillowD && zillowD.results.response != undefined) {
                const Zd_zestimate = zillowD.results.response.zestimate;
                const Zd_rentzestimate = zillowD.results.response.rentzestimate;
                return {
                  amount: (Zd_zestimate.amount.length > 0)
                    ? Zd_zestimate.amount[0]._ : 0,

                  highvaluationRange: (Zd_zestimate.valuationRange.length > 0)
                    ? Zd_zestimate.valuationRange[0].high[0]._ : 0,

                  lowvaluationRange: (Zd_zestimate.valuationRange.length > 0)
                    ? Zd_zestimate.valuationRange[0].low[0]._ : 0,

                  valuechange: (Zd_zestimate.valueChange.length > 0)
                    ? Zd_zestimate.valueChange[0]._ : 0,

                  lastupdate: (Zd_zestimate.valueChange[0].$!=undefined)
                    ? Zd_zestimate.valueChange[0].$.duration : 0,

                  //------------------------------//
                  rentzestimate_amount: (Zd_rentzestimate.amount.length > 0)
                    ? Zd_rentzestimate.amount[0]._ : 0,

                  rentzestimate_highvaluationRange: (Zd_rentzestimate.valuationRange.length > 0)
                    ? Zd_rentzestimate.valuationRange[0].high[0]._ : 0,

                  rentzestimate_lowvaluationRange: (Zd_rentzestimate.valuationRange.length > 0)
                    ? Zd_rentzestimate.valuationRange[0].low[0]._ : 0,

                  rentzestimate_valuechange: (Zd_rentzestimate.valueChange.length > 0)
                    ? Zd_rentzestimate.valueChange[0]._ : 0,

                  rentzestimate_lastupdate: (Zd_rentzestimate.valueChange[0].$!=undefined)
                    ? Zd_rentzestimate.valueChange[0].$.duration : 0
                }
              }
              else {
                return { Code: '1012' }
              }
            })
          };
        }
        else {
          return { Code: '1012' }
        }
      })).subscribe(ResponseData => {
        // console.log(ResponseData);
        if (ResponseData.Code == '1000') {
          this.zestimatedata = ResponseData.zillowres;
          this.zillowUpdated.next({
            zestimate: [...this.zestimatedata]
          });
        }
      });
  }

  getpropertyRef_FileId(id) {
    //console.log(id);
    return this.http.get<{ message: string, Ref_FileId: string }>(BACKEND_URL + 'propertyRef_FileId/' + id)
  }
}
